import { ChartLineUp, CurrencyEur, Door, Info, Ruler } from '@phosphor-icons/react';
import { InnenKarte, KartenTitel, KpiReihe, KpiTile } from '../../../../../components/immobilien/ui';
import { eur } from '../../../../../lib/immobilien/format';
import { useObjektSeite } from '../ObjektSeitenKontext';

/** Panel „Kaltmiete & Mietspiegel“. Mietspiegelwerte sind noch nicht in der Datenbank. */
export function KaltmietePanel() {
  const { uebersicht, kennzahlen: k, zuEinheiten } = useObjektSeite();
  const vermietet = uebersicht.filter(e => e.vermietet);
  const max = Math.max(1, ...vermietet.map(e => (e.flaeche > 0 ? e.kalt / e.flaeche : 0)));

  return (
    <>
      <KpiReihe>
        <KpiTile label="Kaltmiete gesamt" wert={eur(k.kaltSumme)} sub="pro Monat" icon={CurrencyEur} ton="acc" />
        <KpiTile label="Ø je Einheit" wert={k.kaltProEinheit !== null ? eur(k.kaltProEinheit) : '–'} sub={`${k.vermietet} vermietet`} icon={Door} />
        <KpiTile label="Ø je m²" wert={k.kaltProQm !== null ? eur(k.kaltProQm) : '–'} sub="vermietete Fläche" icon={Ruler} />
        <KpiTile label="Jahres-Soll" wert={eur(k.kaltSumme * 12, { nachkomma: 0 })} sub="Kaltmiete × 12" icon={ChartLineUp} ton="ok" />
      </KpiReihe>

      <InnenKarte padding="12px 18px" gap={0}>
        <div style={{ padding: '6px 0 10px' }}><KartenTitel rechts="€/m² im Vergleich der Einheiten">Kaltmiete je Einheit</KartenTitel></div>
        {vermietet.length === 0 && <span style={{ padding: '14px 0', fontSize: 13, color: 'var(--ink3)' }}>Keine vermieteten Einheiten.</span>}
        {vermietet.map(e => {
          const proQm = e.flaeche > 0 ? e.kalt / e.flaeche : null;
          return (
            <button key={e.id} type="button" onClick={() => zuEinheiten(e.id)} className="immo-hover-flaeche grid items-center text-left cursor-pointer"
              style={{ gridTemplateColumns: 'minmax(0,1.6fr) minmax(0,1fr) minmax(0,2fr) 90px', gap: 12, padding: '10px 0', border: 'none', borderTop: '1px solid var(--line)', background: 'transparent', fontSize: 13, color: 'var(--ink)' }}>
              <span className="flex flex-col min-w-0"><b className="truncate" style={{ fontWeight: 700 }}>{e.bezeichnung}</b><span className="truncate" style={{ fontSize: 11, color: 'var(--ink3)' }}>{e.mieter.join(', ')}</span></span>
              <span className="immo-zahl" style={{ fontWeight: 700 }}>{eur(e.kalt)}</span>
              <span className="flex items-center" style={{ gap: 8 }}>
                <span className="flex-1 overflow-hidden" style={{ height: 6, borderRadius: 3, background: 'var(--fill2)' }}>
                  <span style={{ display: 'block', height: '100%', width: proQm !== null ? `${(proQm / max) * 100}%` : 0, borderRadius: 3, background: 'var(--acc)' }} />
                </span>
              </span>
              <span className="immo-zahl" style={{ textAlign: 'right', color: 'var(--ink2)' }}>{proQm !== null ? `${eur(Math.round(proQm * 100) / 100)}/m²` : e.flaeche > 0 ? '–' : 'ohne m²'}</span>
            </button>
          );
        })}
        {vermietet.some(e => e.flaeche === 0) && (
          <span style={{ padding: '10px 0 4px', fontSize: 11, color: 'var(--ink3)' }}>Einheiten „ohne m²“: Wohnfläche fehlt in den Einheitsdaten.</span>
        )}
      </InnenKarte>

      <InnenKarte style={{ flexDirection: 'row', alignItems: 'flex-start', gap: 12 }}>
        <Info weight="fill" size={20} color="var(--info)" style={{ flexShrink: 0, marginTop: 2 }} />
        <span className="flex flex-col" style={{ gap: 3 }}>
          <span style={{ fontSize: 14, fontWeight: 700 }}>Mietspiegel noch nicht hinterlegt</span>
          <span style={{ fontSize: 12, color: 'var(--ink2)', lineHeight: 1.45 }}>
            Für den Vergleich mit der ortsüblichen Vergleichsmiete fehlen Mietspiegelwerte in der Datenbank. Sobald sie gepflegt sind, zeigt dieses Panel Spielraum und Kappungsgrenze je Einheit.
          </span>
        </span>
      </InnenKarte>
    </>
  );
}
